import React from "react";

function Touch() {
  return (
    <>
      <section id="services" className="services-area pt-120 pb-90 fix">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="section-title text-center mb-50 wow fadeInDown animated"
                data-animation="fadeInDown"
                data-delay=".4s"
              >
                <h5>
                  <i className="fal fa-graduation-cap" /> Contact Info
                </h5>
                <h2>Get In Touch</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 col-md-12">
              <div className="services-box text-center">
                <div className="services-icon">
                  <img src="/assets/img/bg/contact-icon01.png" alt="image" />
                </div>
                <div className="services-content2">
                  <h5>
                    <a href="tel:+919986255343">+91 9986255343 (Careers)</a>
                  </h5>
                  <h5>
                    <a href="tel:+919513107575">+91 9513107575 (Admissions)</a>
                  </h5>
                  {/* <h5>
                    <a href="tel:+918071587900">+91 8071587900</a>
                  </h5> */}
                  {/* <p>Phone Support</p> */}
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-12">
              <div className="services-box text-center active">
                <div className="services-icon">
                  <img src="/assets/img/bg/contact-icon02.png" alt="image" />
                </div>
                <div className="services-content2">
                  {/* <h5>
                    <a href="mailto:principal.akaship@yahoo.com">
                      principal.akaship@yahoo.com
                    </a>
                  </h5> */}
                  <h5>
                    <a href="mailto:principal.aip@yahoo.com">
                      principal.aip@yahoo.com
                    </a>
                  </h5>
                  {/* <p>Email Address</p> */}
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-12">
              <div className="services-box text-center">
                <div className="services-icon">
                  <img src="/assets/img/bg/contact-icon03.png" alt="image" />
                </div>
                <div className="services-content2">
                  <h5>
                    <a
                      href="https://maps.app.goo.gl/XW275Pr9toMv4PQJ9"
                      target="_blank"
                    >
                      Anjanadri institute of pharmacy, Sy. No. 43/P-1, Doddajala village, Jala hobli, International Airport Road, Bangalore - 562157
                    </a>
                  </h5>
                  {/* <p>Office Address</p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Touch;
